import 'wretch';
import 'wretch/addons/queryString';
import '../../utils/mParticle/mParticle.js';
import { loadScript } from '../../utils/loadScript/loadScript.js';
import 'fromentries';
import { getSalesforceLanguage } from './getSalesforceLanguage.js';

let initialised = false;
const isBotInitialised = () => initialised;
const initBot = async (props) => {
    if (isBotInitialised()) {
        return window.embeddedservice_bootstrap;
    }
    return new Promise((resolve, reject) => {
        const timeout = setTimeout(() => {
            reject(new Error('Chat initialisation timed out'));
        }, 10000);
        loadScript({ src: props.bootstrapJsSrc })
            .then(() => {
            var _a;
            window.embeddedservice_bootstrap.settings.devMode =
                (_a = props.devMode) !== null && _a !== void 0 ? _a : false;
            window.embeddedservice_bootstrap.settings.language =
                getSalesforceLanguage(props.locale);
            window.embeddedservice_bootstrap.settings.hideChatButtonOnLoad = true;
            window.embeddedservice_bootstrap.init(props.init.orgId, props.init.eswConfigDevName, props.init.siteUrl, { scrt2URL: props.init.scrt2URL });
            window.addEventListener('onEmbeddedMessagingReady', () => {
                clearTimeout(timeout);
                initialised = true;
                resolve(window.embeddedservice_bootstrap);
            }, { once: true });
        })
            .catch(reject)
            .finally(() => {
            clearTimeout(timeout);
        });
    });
};

export { initBot, isBotInitialised };
//# sourceMappingURL=init.js.map
